import React, { Component } from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'
import { DatePicker, Upload, message, Modal, Input, Select } from 'antd';
import SlidersHome from '../common/SlidersHome'
import ajax from '../utils/ajax'
import functions from '../utils/functions'
import Notification from '../common/Notification'

// import { ReactGoogleReviews } from "react-google-reviews";
// import "react-google-reviews/dist/index.css";

//import { ReactComponent as CompanyIcon } from '../../public/assets/img/logo/rehabLogo.png';

// import { WhatsAppWidget } from 'react-whatsapp-widget';
// import 'react-whatsapp-widget/dist/index.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import SlidersHomeTwo from '../common/SlidersHomeTwo'
import SlidersHead from '../common/SlidersHead'

import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import { click } from '@testing-library/user-event/dist/click'


{/* <WhatsAppWidget  phoneNumber="256704667903" /> */ }

const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Option } = Select;

class Dashboard extends Component {



  state = {
    username: '',
    password: '',
    type: '',
    info: '',
    load: false,
    showMsg: false,

    phone: '',
    email: '',
    date: '',
    fullname: '',
    service: '',
    doctor: '',
    message: ''


  }

  onChangeFullname = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ fullname: event.target.value })
  }

  onChangePhone = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ phone: event.target.value })
  }

  onChangeEmail = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ email: event.target.value })
  }

  onChangeType = (value) => {

    console.log("tadaa ", value.target.value)

    this.setState({
      service: value.target.value
    })
  }

  onChangeDoctor = (events) => {
    console.log("tadaa ", events.target.value)
    this.setState({ doctor: events.target.value })
  }

  onChangeDate = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ date: event.target.value })
  }

  onChangeDesc = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ message: event.target.value })
  }




  onPressSchedule = async (event) => {

    event.preventDefault()
    const { phone, email, date, fullname, service, doctor, message } = this.state

    if (phone.length > 0 && email.length > 0 && date.length > 0 && fullname.length > 0 && service.length > 0 && doctor.length > 0 && message.length > 0) {

      this.setState({
        type: '',
        info: '',
        load: true,
        showMsg: false
      })
      //fetch login from the API
      const server_response = await ajax.sendMail(phone, email, date, fullname, service, doctor, message)


      if (server_response.status === "OK") {
        this.setState({
          type: 'alert alert-success',
          info: server_response.message,
          load: '',
        })
        window.location.reload()

      } else {

        this.setState({
          type: 'alert alert-danger',
          info: server_response.message,
          load: '',
        })

      }



    } else {

      this.setState({
        type: 'alert alert-danger',
        info: 'All Fields are required',
        load: false,
      })
    }


  }


  render() {
    const featurableWidgetId = "featurable-879ee8d6-bd09-47c1-8a55-5ba9eba77ae0"

    // window.location.reload();

    return (

      <body>
        {<Header />}

        {/* <div class="header-search-form-wrapper">
            <div class="tx-search-close tx-close"><i class="fa-solid fa-xmark"></i></div>
            <div class="header-search-container">
              <form role="search" class="search-form">
                <input type="search" class="search-field" placeholder="Search …" value="" name="s" />
                <button type="submit" class="search-submit"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                  <path d="M14.3865 12.4626L17.5986 15.6746L16.5379 16.7353L13.3259 13.5233C12.171 14.4473 10.7063 15 9.11328 15C5.38728 15 2.36328 11.976 2.36328 8.25C2.36328 4.524 5.38728 1.5 9.11328 1.5C12.8393 1.5 15.8633 4.524 15.8633 8.25C15.8633 9.843 15.3105 11.3077 14.3865 12.4626ZM12.8818 11.9061C13.7989 10.9609 14.3633 9.6717 14.3633 8.25C14.3633 5.34938 12.0139 3 9.11328 3C6.21266 3 3.86328 5.34938 3.86328 8.25C3.86328 11.1506 6.21266 13.5 9.11328 13.5C10.535 13.5 11.8242 12.9356 12.7694 12.0185L12.8818 11.9061Z" fill="#06030E" />
                </svg></button>
              </form>
            </div>
          </div> */}
        <div class="body-overlay"></div>

        <div class="homepage6-body">
          <div class="vl-offcanvas">
            <div class="vl-offcanvas-wrapper">
              <div class="vl-offcanvas-header d-flex justify-content-between align-items-center mb-90">
                <div class="vl-offcanvas-logo">
                  <a href="/"><img src="assets/img/logo/rehabLogo.png" alt="" /></a>
                </div>
                <div class="vl-offcanvas-close">
                  <button class="vl-offcanvas-close-toggle"><i class="fa-solid fa-xmark"></i></button>
                </div>
              </div>

              <div class="vl-offcanvas-menu d-lg-none mb-40">
                <nav></nav>
              </div>

              <div class="space20"></div>
              <div class="vl-offcanvas-info">

                <div class="btn-area1">

                  <div class="btn-area1">
                    <a href="https://wa.me/256755260852" target='_blank' class="vl-btn7"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <g clip-path="url(#clip0_5832_90599)">
                        <path d="M4.32688 1.17695C4.79912 1.27456 5.1752 1.59185 5.40887 2.01104L6.15321 3.34641C6.42738 3.83825 6.65811 4.25215 6.80878 4.61195C6.96862 4.99364 7.06355 5.37002 7.02016 5.78615C6.97676 6.20229 6.80622 6.55099 6.57107 6.89148C6.3494 7.21245 6.03823 7.56985 5.66848 7.99454L4.57431 9.25135C4.37824 9.4766 4.2802 9.58919 4.27124 9.72994C4.26228 9.87069 4.34263 9.99094 4.50333 10.2314C5.87299 12.2806 7.71894 14.1272 9.76983 15.498C10.0103 15.6587 10.1305 15.739 10.2712 15.7301C10.412 15.7211 10.5247 15.6231 10.7498 15.427L12.0067 14.3328C12.4314 13.963 12.7888 13.6519 13.1098 13.4302C13.4502 13.195 13.799 13.0245 14.2151 12.9811C14.6312 12.9377 15.0077 13.0327 15.3893 13.1925C15.7491 13.3432 16.163 13.5739 16.6547 13.848L17.9902 14.5924C18.4094 14.8261 18.7267 15.2022 18.8243 15.6744C18.9229 16.1515 18.7775 16.6312 18.4562 17.0254C17.2904 18.4557 15.4227 19.3664 13.4633 18.9711C12.259 18.7282 11.0707 18.3234 9.63342 17.4992C6.74558 15.843 4.15636 13.2524 2.50212 10.3679C1.67786 8.9306 1.2731 7.74232 1.03015 6.53794C0.634898 4.57858 1.54559 2.71085 2.9759 1.5451C3.37009 1.22381 3.84971 1.07834 4.32688 1.17695Z" fill="white" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3045 1.54C11.432 1.0978 11.894 0.842779 12.3362 0.970388C15.559 1.90041 18.0973 4.43862 19.0275 7.66132C19.155 8.1035 18.9 8.56545 18.4579 8.69304C18.0157 8.8207 17.5537 8.5657 17.4261 8.1235C16.6548 5.45101 14.5466 3.34295 11.874 2.57171C11.4319 2.4441 11.1769 1.98219 11.3045 1.54ZM10.793 5.47187C10.973 5.04825 11.4622 4.85066 11.8859 5.03055C13.2706 5.6186 14.3793 6.72725 14.9673 8.11199C15.1472 8.53562 14.9496 9.02487 14.526 9.20479C14.1024 9.38462 13.6131 9.18704 13.4332 8.76345C13.014 7.77614 12.2217 6.9839 11.2344 6.56463C10.8108 6.38474 10.6132 5.8955 10.793 5.47187Z" fill="white" />
                      </g>
                      <defs>
                        <clipPath id="clip0_5832_90599">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> (0) 755 260852</a>
                  </div>

                  <br />

                  <a href="https://wa.me/256755260852" class="vl-btn4">WhatsApp<span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                  </svg></span></a>
                </div>


              </div>

              <div class="space20"></div>
              <div class="vl-offcanvas-info">
                <h3 class="vl-offcanvas-sm-title">Contact Us</h3>
                <div class="space20"></div>
                <span><a href="#"> <i class="fa-solid fa-phone"></i> +256755260852</a></span>
                <span><a href="#"><i class="fa-regular fa-envelope"></i> info@ntindamedic.com</a></span>
                <span><a href="#"><i class="fa-solid fa-location-dot"></i> Ntinda Stretcher Road</a></span>
              </div>
              <div class="space20"></div>
              <div class="vl-offcanvas-social">
                <h3 class="vl-offcanvas-sm-title">Follow Us</h3>
                <div class="space20"></div>
                <a href="#"><i class="fab fa-facebook-f"></i></a>
                <a href="#"><i class="fab fa-twitter"></i></a>
                <a href="#"><i class="fab fa-linkedin-in"></i></a>
                <a href="#"><i class="fab fa-instagram"></i></a>
              </div>

            </div>
          </div>
          <div class="vl-offcanvas-overlay"></div>
        </div>

        <div class="hero6-section-area">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="hero-header6">
                  <h5><img src="assets/img/icons/sub-logo1.svg" alt="" /> Realign Your Health Naturally.</h5>
                  <div class="space22"></div>
                  <h2 class="text-anime-style-3">Your Journey to a Healthier Spine and Happier body Starts Here.</h2>
                  <div class="space16"></div>
                  <p data-aos-duration="900">Experience the difference of personalized chiropractic and Physiotherapy care <br class="d-lg-block d-none" /> designed to help you move better, feel better, & live better.</p>
                  <div class="space32"></div>
                  <div class="btn-area1" data-aos-duration="1000">
                    <Link to="#" class="vl-btn7">Schedule a Consultation</Link>
                    <a href="assets/video/homevid.mp4" class="popup-youtube"><span><svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
                      <path d="M7.68483 21.3689C7.38881 21.3684 7.09802 21.2908 6.84108 21.1438C6.26251 20.8159 5.90283 20.1795 5.90283 19.4886V5.50642C5.90283 4.81358 6.26251 4.17908 6.84108 3.85122C7.10414 3.70004 7.40298 3.62229 7.70636 3.62611C8.00975 3.62993 8.30654 3.71517 8.56571 3.87292L20.5156 11.026C20.7647 11.1822 20.97 11.399 21.1123 11.6562C21.2546 11.9134 21.3293 12.2026 21.3293 12.4965C21.3293 12.7905 21.2546 13.0796 21.1123 13.3368C20.97 13.594 20.7647 13.8109 20.5156 13.9671L8.56378 21.1221C8.29855 21.2824 7.99476 21.3677 7.68483 21.3689Z" fill="#090B0E" />
                    </svg></span> Play Video</a>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="hero-shape-area">
                  <img src="/assets/img/elements/elements25.png" alt="" class="elements25" />
                  <div class="hero8-images-area "> {/** owl-carousel */}

                    {< SlidersHead />}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="about-others-section-area sp1">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="about-images-area6">
                  <div class="row">
                    <div class="col-lg-6 col-md-6">
                      <div class="img1">
                        <div class="img ">
                          <img src="assets/img/all-images/about/about-img16.png" alt="" />
                        </div>
                        <div class="cricle-arrow-area">
                          <img src="assets/img/elements/elements27.png" alt="" class="elements27 keyframe5" />
                          <div class="arrow">
                            <a href="about.html"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M2 22L22 2M22 2H4M22 2V20" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6">
                      <div class="space100"></div>
                      <div class="img2  image-anime">
                        <img src="assets/img/all-images/about/about-img17.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="heading6">
                  <h5 class="vl-section-subtitle"><img src="/assets/img/icons/sub-logo1.svg" alt="" /> About Us</h5>
                  <div class="space24"></div>
                  <h2 class="vl-section-title text-anime-style-3">Leading the Way In Pain Relief and Holistic Healing.</h2>
                  <div class="space16"></div>
                  <p data-aos-duration="900">We believe that true wellness starts with a healthy spine and happier body. Our mission is to provide expert chiropractic and Physiotherapy care tailored to your unique needs, helping you move freely, live pain-free, & achieve your full potential.</p>
                  <div class="space10"></div>
                  <ul data-aos-duration="1000">
                    <li><img src="assets/img/icons/about-icons1.svg" alt="" /> Redefining Chiropractic and Physiotherapy Care for a Healthier You.</li>
                    <li><img src="assets/img/icons/about-icons1.svg" alt="" /> Experience the Difference of Personalized Care.</li>
                    <li><img src="assets/img/icons/about-icons1.svg" alt="" /> Your Trusted Partners in Health and Healing.</li>
                  </ul>
                  <div class="space32"></div>
                  <div class="btn-area1" data-aos-duration="1200">
                    <Link to="/about-us" class="vl-btn7">Learn More</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="service8-scetion-area sp2">
          <div class="container">
            <div class="row">
              <div class="col-lg-5 m-auto">
                <div class="heading6 text-center space-margin60">
                  <h5 class="vl-section-subtitle"><img src="/assets/img/icons/sub-logo1.svg" alt="" /> Our Service</h5>
                  <div class="space24"></div>
                  <h2 class="vl-section-title text-anime-style-3">Specialized Treatments for Lasting Pain Relief.</h2>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-6" data-aos-duration="700">
                <div class="service8-boxarea">
                  <div class="icons">
                    <img src="assets/img/icons/service25.svg" alt="" />
                  </div>
                  <div class="space24"></div>
                  <a href="" class="title">Physiotherapy services</a>
                  <div class="space16"></div>
                  <p>We provide client-centered care focused on helping you recover, eliminate pain, post-surgery rehabilitation and restoring normal movement of joints, nerves, and muscles.</p>
                  <div class="space24"></div>
                  {/* <a href="" class="readmore">Read More <i class="fa-solid fa-arrow-right"></i></a> */}
                </div>
              </div>

              <div class="col-lg-4 col-md-6" data-aos-duration="1100">
                <div class="service8-boxarea">
                  <div class="icons">
                    <img src="assets/img/icons/service29.html" alt="" />
                  </div>
                  <div class="space24"></div>
                  <a href="service-single.html" class="title">Orthopedic services</a>
                  <div class="space16"></div>
                  <p>Our orthopedic services includes, Treatment of Musculoskeletal disorders such as Rheumatoid Arthritis, Osteoarthritis and gout, Fixation of open fractures and injuries.</p>
                  <div class="space24"></div>
                  {/* <a href="service-single.html" class="readmore">Read More <i class="fa-solid fa-arrow-right"></i></a> */}
                </div>
              </div>

              <div class="col-lg-4 col-md-6" data-aos-duration="900">
                <div class="service8-boxarea">
                  <div class="icons">
                    <img src="assets/img/icons/service27.svg" alt="" />
                  </div>
                  <div class="space24"></div>
                  <a href="" class="title">Sports Injury Rehabilitation</a>
                  <div class="space16"></div>
                  <p>We treat a wide range of conditions including skeleton injuries, acute Sprains and strains, shoulder and joint dislocations, Foot and ankle disfunctions,tendonitis.</p>
                  <div class="space24"></div>
                  {/* <a href="service-single.html" class="readmore">Read More <i class="fa-solid fa-arrow-right"></i></a> */}
                </div>
              </div>

              <div class="col-lg-4 col-md-6" data-aos-duration="800">
                <div class="service8-boxarea">
                  <div class="icons">
                    <img src="assets/img/icons/service26.svg" alt="" />
                  </div>
                  <div class="space24"></div>
                  <a href="" class="title">Pediatric Rehabilitation</a>
                  <div class="space16"></div>
                  <p>Our team works closely with your pediatrician to provide customized rehabilitation plans to address a wide range of symptoms and maximizing active participation of children.</p>
                  <div class="space24"></div>
                  {/* <a href="service-single.html" class="readmore">Read More <i class="fa-solid fa-arrow-right"></i></a> */}
                </div>
              </div>

              <div class="col-lg-4 col-md-6" data-aos-duration="1200">
                <div class="service8-boxarea">
                  <div class="icons">
                    <img src="assets/img/icons/service25.svg" alt="" />
                  </div>
                  <div class="space24"></div>
                  <a href="service-single.html" class="title">Stroke & Neurological Rehabilitation</a>
                  <div class="space16"></div>
                  <p>We Specialize in the diagnosis, treatment and monitoring of Early neurological rehabilitation to help optimize individual physical and cognitive recovery and enhance quality of life.</p>
                  <div class="space24"></div>
                  {/* <a href="service-single.html" class="readmore">Read More <i class="fa-solid fa-arrow-right"></i></a> */}
                </div>
              </div>

              <div class="col-lg-4 col-md-6" data-aos-duration="1000">
                <div class="service8-boxarea">
                  <div class="icons">
                    <img src="assets/img/icons/service28.svg" alt="" />
                  </div>
                  <div class="space24"></div>
                  <a href="service-single.html" class="title">Home Care Services</a>
                  <div class="space16"></div>
                  <p>We provide Skilled nursing and Physiotherapy care in the comfort of your home like wound dressing, administration, and monitoring vital signs to ensure your health needs are met.</p>
                  <div class="space24"></div>
                  {/* <a href="service-single.html" class="readmore">Read More <i class="fa-solid fa-arrow-right"></i></a> */}
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="case1-section-area sp1">
          <div class="container">
            <div class="row">
              <div class="col-lg-5">
                <div class="heading6 space-margin60">
                  <h5 class="vl-section-subtitle"><img src="assets/img/icons/sub-logo1.svg" alt="" /> Case Studies</h5>
                  <div class="space24"></div>
                  <h2 class="vl-section-title text-anime-style-3">Restoring Health, One Adjustment at a Time.</h2>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">

                {<SlidersHome />}

              </div>
            </div>
          </div>
        </div>

        <div class="testimonial8-section-area sp1">
          <img src="assets/img/elements/elements25.png" alt="" class="elements25" />
          <div class="container">
            <div class="row">
              <div class="col-lg-6 m-auto">
                <div class="heading6 text-center space-margin60">
                  <h5 class="vl-section-subtitle"><img src="assets/img/icons/sub-logo1.svg" alt="" /> Client Feedback</h5>
                  <div class="space24"></div>
                  <h2 class="vl-section-title text-anime-style-3">What Our Patients Are Saying</h2>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">

                {/* <ReactGoogleReviews layout="carousel" featurableId={"879ee8d6-bd09-47c1-8a55-5ba9eba77ae0"} /> */}

                {/* <div id="featurable-879ee8d6-bd09-47c1-8a55-5ba9eba77ae0" data-featurable-async ></div> */}
                <iframe src="https://featurable.com/widgets/v2/879ee8d6-bd09-47c1-8a55-5ba9eba77ae0" style={{ width: '100%', height: '470px', border: '0', allowfullscreen: '', loading: 'lazy' }} ></iframe>

              </div>
            </div>
          </div>
        </div>

        <div class="team6-section-area sp1">
          <div class="container">
            <div class="row">
              <div class="col-lg-5">
                <div class="heading6 space-margin60">
                  <h5 class="vl-section-subtitle"><img src="assets/img/icons/sub-logo1.svg" alt="" /> 10+ Experienced doctors</h5>
                  <div class="space24"></div>
                  <h2 class="vl-section-title text-anime-style-3">Our Skilled Team, Your Health Partners</h2>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">

                {<SlidersHomeTwo />}

              </div>
            </div>
          </div>
        </div>


        <div class="contact6-section-area sp1">
          <div class="container">
            <div class="row">
              <div class="col-lg-7 m-auto">
                <div class="heading6 text-center space-margin60">
                  <h5 class="vl-section-subtitle lies"><img src="assets/img/icons/sub-logo1.svg" alt="" /> Book Your Consultation Now</h5>
                  <h5 class="vl-section-subtitle easy"><img src="assets/img/icons/sub-logo1.svg" alt="" /> Our Map View</h5>
                  <div class="space24"></div>
                  <h2 class="vl-section-title text-anime-style-3 facts">Schedule Appointment Today</h2>
                  <h2 class="vl-section-title text-anime-style-3 easy">Navigate To Ntinda Medical Easily</h2>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="contact-boxarea">
                  <h4>book An Appointment</h4>
                  <div class="space20"></div>
                  <p>Scheduling consultation is first step toward achieving <br class="d-lg-block d-none" /> your health and wellness goals with the best support </p>
                  <div class="space6"></div>

                  <form method="post" onSubmit={this.onPressSchedule} >

                    {/* onSubmit={this.onPressLogin} */}

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="input-area">
                          {/* <input type="text" placeholder="Full Name*" onChange={this.onChangeFullname} /> */}
                          <Input size="large" type='text' placeholder="Full Name*" onChange={this.onChangeFullname} />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          {/* <input type="text" placeholder="Phone Number*" onChange={this.onChangePhone} /> */}
                          <Input size="large" type='text' placeholder="Phone Number*" onChange={this.onChangePhone} />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          {/* <input type="email" placeholder="Email Address*" onChange={this.onChangeEmail} /> */}
                          <Input size="large" type='text' placeholder="Email Address*" onChange={this.onChangeEmail} />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          <select class="nice-select" onChange={this.onChangeType}>
                            <option value="" data-display="Service Type">Service Type</option>
                            <option value="Consultation"> Consultation</option>
                            <option value="General Orthopedic Services"> General Orthopedic Services</option>
                            <option value="Specialist Services"> Specialist Services</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          <select class=" nice-select" onChange={this.onChangeDoctor}>
                            <option value="" data-display="Select Doctor*">Select Doctor*</option>
                            <option value="Dr. Julius Okello"> Dr. Julius Okello - Team Lead</option>
                            <option value="Dr. Nicholas Byaruhanga"> Dr. Nicholas Byaruhanga - Nutritionist</option>
                            <option value="Dr. Ochan Innocent"> Dr. Ochan Innocent - Physiotherapist</option>
                            <option value="Dr. Natukunda Patience"> Dr. Natukunda Patience - Nursing</option>
                            <option value="Dr. Ebyarimpa Medard"> Dr. Ebyarimpa Medard - surgeon</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          <input type="date" onChange={this.onChangeDate} />
                          <input type='text' name='klk' ></input>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="input-area">

                          <textarea placeholder="Your Message" onChange={this.onChangeDesc}></textarea>

                          {/* <TextArea
                              showCount
                              maxLength={100}
                              style={{ height: 120, resize: 'none' }}
                              onChange={this.handleDescription}
                              placeholder="About the adventure"
                            /> */}
                        </div>


                        <Notification
                          message={{
                            type: this.state.type,
                            info: this.state.info,
                          }}
                        />

                      </div>


                      <div class="col-lg-12">
                        <div class="space10"></div>
                        <div class="input-area">

                          <button type="submit" class="vl-btn7" disabled={this.state.load}>

                            {this.state.load ? (<>
                              <span style={{ margin: '0 20px' }} class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              Scheduling your  ...
                            </>
                            ) : (<>Schedule Your Visit Now</>)}
                          </button>

                        </div>
                      </div>
                    </div>


                  </form>

                </div>
              </div>

              <div class="col-lg-6">
                <div class="contact-maps-area">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255.7983975595858!2d32.61703613133043!3d0.34442818517578067!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbb001196709b%3A0x438a0f31ceff10df!2sThe%20Ntinda%20Medical%20and%20Rehabilitation%20Centre!5e0!3m2!1sen!2sug!4v1763327885215!5m2!1sen!2sug" style={{ width: '600', height: '450', border: '0', allowfullscreen: '', loading: 'lazy' }} ></iframe>
                  {/* width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cta6-section-area">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="cta7-bg-area">
                  <div class="row align-items-center">
                    <div class="col-lg-6">
                      <div class="cta-content-area heading1">
                        <h2 class="text-anime-style-3">Experience Pain Relief. Start Your Journey Now.</h2>
                        <div class="space16"></div>
                        <p data-aos-duration="900">Don’t let pain hold you back any longer. Take the first step toward a healthier, pain-free life with expert chiropractic and Physiotherapists.</p>
                        <div class="space24"></div>
                        <div class="btn-area1">
                          <a href="#contact-us" class="vl-btn7 btn1">Start Your Journey</a>
                          <a href="#contact-us" class="vl-btn7 btn2">Contact Us</a>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                    <div class="col-lg-4">
                      <div class="form-boxarea">
                        <h5>We Are Committed to you</h5>
                        <div class="space16"></div>
                        <p>Stay Update Whit Exclusive Tips Insights and Special Offers Today!</p>
                        <div class="space32"></div>
                        <form>
                          <input type="text" disabled />
                          <button type="submit">
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M6.16748 17.8322L17.8341 6.16553" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M8.35498 6.16553H17.8341V15.6447" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> */}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>



        {< Footer />}


      </body>

    )
  }
}
export default Dashboard